import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import MyTextInput from "../../../common/form/MyTextInput";
import MyDateInput from "../../../common/form/MyDateInput";
import {
  Grid,
  Form,
  Segment,
  Button,
  Label,
  Checkbox,
  Dropdown,
} from "semantic-ui-react";

const ConformiteAdd3 = ({ next, prev, userList }) => {
  const [listUsers, setLlistUsers] = useState([]);

  useEffect(() => {
    if (userList && userList.userByUserType && userList.userByUserType.items) {
      setLlistUsers(userList.userByUserType.items);
    }
  }, [userList]);

  const listtemp = listUsers.map((item) => {
    const container = {};
    container.key = item.name;
    container.value = item.name;
    container.text = item.name;
    container.icon = "user";
    return container;
  });

  const { userEmail } = useSelector((state) => state.authReducer);

  const [decision, setDecision] = useState("");
  const handleTextAreaDecision = (event) => {
    setDecision(event.target.value);
  };

  const [constatControl, setConstatControl] = useState("");
  const handleTextAreaConstatControl = (event) => {
    setConstatControl(event.target.value);
  };

  const [isCheckedCloturee, setIsCheckedCloturee] = useState(false);
  const handleActionCloturee = (event, { value }) => {
    setIsCheckedCloturee(!isCheckedCloturee);
  };

  const [isVisaTraitment, setIsVisaTraitment] = useState(false);
  const handleActionVisaTraitment = (event, { value }) => {
    setIsVisaTraitment(!isVisaTraitment);
  };

  const [isActionVisaSuivi, setIsActionVisaSuivi] = useState(false);
  const handleActionVisaSuivi = (event, { value }) => {
    setIsActionVisaSuivi(!isActionVisaSuivi);
  };

  const initialValues = {
    constats: "",
    taux: "",
    userRQA1: "",
    dateConstat1: "",
    userRQA2: "",
    dateConstat2: "",
    constatEval: "",
    qseId: "",
  };

  const validationSchema = Yup.object().shape({});

  const handleSubmit = (values) => {
    values.createdAt = Date.now();
    values.userId = userEmail;
    values.decision = decision;
    values.constatControl = constatControl;
    values.cloturee = isCheckedCloturee ? "Oui" : "Non";
    values.visaTraitment = isVisaTraitment ? "Oui" : "Non";
    values.visaSuivi = isActionVisaSuivi ? "Oui" : "Non";
    // values.qseId = conformite.qseId;

    // alert(JSON.stringify(values, null, 2));

    next();
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <Form size="large" onSubmit={handleSubmit}>
          <Segment.Group>
            <Segment color="blue">
              <Label as="a" color="blue" ribbon>
                Resultats (verification de la mise en Oeuvre):
              </Label>
              <Form.Group widths="equal">
                <Form.Field>
                  <b>Par le RQA (Nom et Visa)</b>
                  <Dropdown
                    placeholder="Par le RQA (Nom et Visa)"
                    name="userRQA1"
                    fluid
                    selection
                    options={listtemp}
                  />
                </Form.Field>
                <MyDateInput
                  label="Date"
                  name="dateConstat1"
                  placeholderText="Date constat"
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeCaption="time"
                  dateFormat="MMMM d, yyyy h:mm a"
                  autoComplete="off"
                />
              </Form.Group>
            </Segment>

            <Segment color="blue">
              <Label as="a" color="blue" ribbon>
                Evaluation de l'efficacite (Dans un delai de 60 apres la mise en
                oeuvre des actions):
              </Label>

              <Form.TextArea
                name="constatControl"
                label=" Constats après contrôle"
                rows={3}
                onChange={handleTextAreaConstatControl}
              ></Form.TextArea>
              <Form.Group widths="equal">
                <MyTextInput
                  name="constatEval"
                  label="Constat de l’évaluation de l’efficacité"
                  placeholder="Constat de l’évaluation de l’efficacité"
                />
                <MyTextInput
                  name="taux"
                  label="Taux d’efficacité"
                  placeholder="Taux d’efficacité"
                />
                <Form.Field>
                  <b>Par le RQA (Nom et Visa)</b>
                  <Dropdown
                    placeholder="Par le RQA (Nom et Visa)"
                    name="userRQA2"
                    fluid
                    selection
                    options={listtemp}
                  />
                </Form.Field>

                <MyDateInput
                  label="Date"
                  name="dateConstat2"
                  placeholderText="Date constat"
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeCaption="time"
                  dateFormat="MMMM d, yyyy h:mm a"
                  autoComplete="off"
                />
              </Form.Group>
              <Form.TextArea
                name="decision"
                label="Décision de responsable de suivi"
                placeholder="Décision de responsable de suivi"
                rows={5}
                onChange={handleTextAreaDecision}
              ></Form.TextArea>
              <Form.Field
                control={Checkbox}
                label="Action clôturée"
                onChange={handleActionCloturee}
                checked={isCheckedCloturee}
              />
            </Segment>

            <Segment color="blue">
              <Label as="a" color="blue" ribbon>
                Visas
              </Label>
              <Grid stackable columns={2}>
                <Grid.Column>
                  <Segment>
                    <Form.Group inline>
                      <Form.Field
                        control={Checkbox}
                        label="Visa du Responsable traitement"
                        value="Oui"
                        onChange={handleActionVisaTraitment}
                      />
                    </Form.Group>
                  </Segment>
                </Grid.Column>
                <Grid.Column>
                  <Segment>
                    <Form.Group inline>
                      <Form.Field
                        control={Checkbox}
                        label="Visa du Responsable suivi"
                        value="Oui"
                        onChange={handleActionVisaSuivi}
                      />
                    </Form.Group>
                  </Segment>
                </Grid.Column>
              </Grid>
            </Segment>
            <Segment textAlign="center">
              <Button.Group>
                <Button
                  onClick={prev}
                  fluid
                  to="#"
                  type="submit"
                  floated="right"
                  content="Precedent"
                />
                <Button.Or text="OU" />
                <Button
                  fluid
                  type="submit"
                  floated="right"
                  positive
                  content="Suivant"
                />
              </Button.Group>
            </Segment>
          </Segment.Group>
        </Form>
      )}
    </Formik>
  );
};

export default ConformiteAdd3;
